import React, { useEffect, useState } from "react";
import Header from "../layouts/Header/Header";
import Footer from "../layouts/Footer";

const Blogs = () => {
  return (
    <div
      className="hero heros blogs"
      style={{
        height: "auto !important ",
        background: " linear-gradient(61deg, #070707 50.84%, #222 96.86%)",
      }}
    >
      <div className="px-3 py-3 px-xxl-4 py-xxl-4">
        <Header />

        <h1 className="text-center gradient-text  mt-5 mb- 5">News & Blogs</h1>

        <div className="container mt-5">
          <div className="row mt-5 ">
            <div className="col-lg-4 mb-3">
              <div className="blogs-image">
                <img src="/assets/images/blogs.jpg" alt="blogs" />
              </div>
            </div>
            <div className="col-lg-8 mb-3">
              <h3>
                Cosmic Network Launches <br /> Revolutionary
              </h3>
              <p>
                Recent events, such as Pakistan's widespread VPN restrictions
                and Brazil's escalating internet control measures, highlight the
                urgent need for truly decentralized privacy solutions," says
                Asad Siddiqui,
              </p>
              <div className="d-flex align-items-center justify-content-between justify-content-md-start  gap-3">
                <span style={{ cursor: "pointer" }}>
                  Read article
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.55781 15.058L13.4914 6.12514H6.875C6.70924 6.12514 6.55027 6.05929 6.43306 5.94208C6.31585 5.82487 6.25 5.6659 6.25 5.50014C6.25 5.33438 6.31585 5.17541 6.43306 5.0582C6.55027 4.94099 6.70924 4.87514 6.875 4.87514H15C15.1658 4.87514 15.3247 4.94099 15.4419 5.0582C15.5592 5.17541 15.625 5.33438 15.625 5.50014V13.6251C15.625 13.7909 15.5592 13.9499 15.4419 14.0671C15.3247 14.1843 15.1658 14.2501 15 14.2501C14.8342 14.2501 14.6753 14.1843 14.5581 14.0671C14.4408 13.9499 14.375 13.7909 14.375 13.6251V7.00873L5.44219 15.9423C5.38412 16.0004 5.31518 16.0465 5.23931 16.0779C5.16344 16.1093 5.08212 16.1255 5 16.1255C4.91788 16.1255 4.83656 16.1093 4.76069 16.0779C4.68482 16.0465 4.61588 16.0004 4.55781 15.9423C4.49974 15.8843 4.45368 15.8153 4.42225 15.7395C4.39083 15.6636 4.37465 15.5823 4.37465 15.5001C4.37465 15.418 4.39083 15.3367 4.42225 15.2608C4.45368 15.185 4.49974 15.116 4.55781 15.058Z"
                      fill="url(#paint0_linear_3486_46993)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3486_46993"
                        x1="5.45461"
                        y1="7.07477"
                        x2="12.6011"
                        y2="14.393"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00D6FF" />
                        <stop offset="1" stop-color="#00FF86" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
                <div className="posted-date">posted 3 days ago</div>
              </div>
            </div>
          </div>{" "}
          <div className="row mt-5">
            <div className="col-lg-4 mb-3">
              <div className="blogs-image">
                <img src="/assets/images/blogs.jpg" alt="blogs" />
              </div>
            </div>
            <div className="col-lg-8 mb-3">
              <h3>
                Cosmic Network Launches <br /> Revolutionary
              </h3>
              <p>
                Recent events, such as Pakistan's widespread VPN restrictions
                and Brazil's escalating internet control measures, highlight the
                urgent need for truly decentralized privacy solutions," says
                Asad Siddiqui,
              </p>
              <div className="d-flex align-items-center gap-3">
                <span style={{ cursor: "pointer" }}>
                  Read article
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.55781 15.058L13.4914 6.12514H6.875C6.70924 6.12514 6.55027 6.05929 6.43306 5.94208C6.31585 5.82487 6.25 5.6659 6.25 5.50014C6.25 5.33438 6.31585 5.17541 6.43306 5.0582C6.55027 4.94099 6.70924 4.87514 6.875 4.87514H15C15.1658 4.87514 15.3247 4.94099 15.4419 5.0582C15.5592 5.17541 15.625 5.33438 15.625 5.50014V13.6251C15.625 13.7909 15.5592 13.9499 15.4419 14.0671C15.3247 14.1843 15.1658 14.2501 15 14.2501C14.8342 14.2501 14.6753 14.1843 14.5581 14.0671C14.4408 13.9499 14.375 13.7909 14.375 13.6251V7.00873L5.44219 15.9423C5.38412 16.0004 5.31518 16.0465 5.23931 16.0779C5.16344 16.1093 5.08212 16.1255 5 16.1255C4.91788 16.1255 4.83656 16.1093 4.76069 16.0779C4.68482 16.0465 4.61588 16.0004 4.55781 15.9423C4.49974 15.8843 4.45368 15.8153 4.42225 15.7395C4.39083 15.6636 4.37465 15.5823 4.37465 15.5001C4.37465 15.418 4.39083 15.3367 4.42225 15.2608C4.45368 15.185 4.49974 15.116 4.55781 15.058Z"
                      fill="url(#paint0_linear_3486_46993)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3486_46993"
                        x1="5.45461"
                        y1="7.07477"
                        x2="12.6011"
                        y2="14.393"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00D6FF" />
                        <stop offset="1" stop-color="#00FF86" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
                <div className="posted-date">posted 3 days ago</div>
              </div>
            </div>
          </div>{" "}
          <div className="row mt-5">
            <div className="col-lg-4 mb-3">
              <div className="blogs-image">
                <img src="/assets/images/blogs.jpg" alt="blogs" />
              </div>
            </div>
            <div className="col-lg-8 mb-3">
              <h3>
                Cosmic Network Launches <br /> Revolutionary
              </h3>
              <p>
                Recent events, such as Pakistan's widespread VPN restrictions
                and Brazil's escalating internet control measures, highlight the
                urgent need for truly decentralized privacy solutions," says
                Asad Siddiqui,
              </p>
              <div className="d-flex align-items-center gap-3">
                <span style={{ cursor: "pointer" }}>
                  Read article
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.55781 15.058L13.4914 6.12514H6.875C6.70924 6.12514 6.55027 6.05929 6.43306 5.94208C6.31585 5.82487 6.25 5.6659 6.25 5.50014C6.25 5.33438 6.31585 5.17541 6.43306 5.0582C6.55027 4.94099 6.70924 4.87514 6.875 4.87514H15C15.1658 4.87514 15.3247 4.94099 15.4419 5.0582C15.5592 5.17541 15.625 5.33438 15.625 5.50014V13.6251C15.625 13.7909 15.5592 13.9499 15.4419 14.0671C15.3247 14.1843 15.1658 14.2501 15 14.2501C14.8342 14.2501 14.6753 14.1843 14.5581 14.0671C14.4408 13.9499 14.375 13.7909 14.375 13.6251V7.00873L5.44219 15.9423C5.38412 16.0004 5.31518 16.0465 5.23931 16.0779C5.16344 16.1093 5.08212 16.1255 5 16.1255C4.91788 16.1255 4.83656 16.1093 4.76069 16.0779C4.68482 16.0465 4.61588 16.0004 4.55781 15.9423C4.49974 15.8843 4.45368 15.8153 4.42225 15.7395C4.39083 15.6636 4.37465 15.5823 4.37465 15.5001C4.37465 15.418 4.39083 15.3367 4.42225 15.2608C4.45368 15.185 4.49974 15.116 4.55781 15.058Z"
                      fill="url(#paint0_linear_3486_46993)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3486_46993"
                        x1="5.45461"
                        y1="7.07477"
                        x2="12.6011"
                        y2="14.393"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00D6FF" />
                        <stop offset="1" stop-color="#00FF86" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
                <div className="posted-date">posted 3 days ago</div>
              </div>
            </div>
          </div>{" "}
          <div className="row mt-5">
            <div className="col-lg-4 mb-3">
              <div className="blogs-image">
                <img src="/assets/images/blogs.jpg" alt="blogs" />
              </div>
            </div>
            <div className="col-lg-8 mb-3">
              <h3>
                Cosmic Network Launches <br /> Revolutionary
              </h3>
              <p>
                Recent events, such as Pakistan's widespread VPN restrictions
                and Brazil's escalating internet control measures, highlight the
                urgent need for truly decentralized privacy solutions," says
                Asad Siddiqui,
              </p>
              <div className="d-flex align-items-center gap-3">
                <span style={{ cursor: "pointer" }}>
                  Read article
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.55781 15.058L13.4914 6.12514H6.875C6.70924 6.12514 6.55027 6.05929 6.43306 5.94208C6.31585 5.82487 6.25 5.6659 6.25 5.50014C6.25 5.33438 6.31585 5.17541 6.43306 5.0582C6.55027 4.94099 6.70924 4.87514 6.875 4.87514H15C15.1658 4.87514 15.3247 4.94099 15.4419 5.0582C15.5592 5.17541 15.625 5.33438 15.625 5.50014V13.6251C15.625 13.7909 15.5592 13.9499 15.4419 14.0671C15.3247 14.1843 15.1658 14.2501 15 14.2501C14.8342 14.2501 14.6753 14.1843 14.5581 14.0671C14.4408 13.9499 14.375 13.7909 14.375 13.6251V7.00873L5.44219 15.9423C5.38412 16.0004 5.31518 16.0465 5.23931 16.0779C5.16344 16.1093 5.08212 16.1255 5 16.1255C4.91788 16.1255 4.83656 16.1093 4.76069 16.0779C4.68482 16.0465 4.61588 16.0004 4.55781 15.9423C4.49974 15.8843 4.45368 15.8153 4.42225 15.7395C4.39083 15.6636 4.37465 15.5823 4.37465 15.5001C4.37465 15.418 4.39083 15.3367 4.42225 15.2608C4.45368 15.185 4.49974 15.116 4.55781 15.058Z"
                      fill="url(#paint0_linear_3486_46993)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3486_46993"
                        x1="5.45461"
                        y1="7.07477"
                        x2="12.6011"
                        y2="14.393"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00D6FF" />
                        <stop offset="1" stop-color="#00FF86" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
                <div className="posted-date">posted 3 days ago</div>
              </div>
            </div>
          </div>
          <nav aria-label="Page navigation example mt-5">
            <ul class="pagination mt-5">
              <li class="page-item">
                <a class="page-link " href="#">
                  Prev
                </a>
              </li>
              <li class="page-item">
                <a class="page-link active" href="#">
                  1
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  2
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  3
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;
